/* YNS Hero Slides: carousel + offer side tab. One script for every .ynsh section on the page. */
(function(){
  function init(root){
    if(!root||root.dataset.ready)return;root.dataset.ready='1';
    var design=!!(window.Shopify&&Shopify.designMode);
    var offer=document.getElementById('ynsh-offer-'+root.dataset.section);
    if(offer){
      var key='ynsh-offer-dismissed',gone=false;
      try{gone=sessionStorage.getItem(key)==='1';}catch(e){}
      if(!gone||design)offer.hidden=false;
      var x=offer.querySelector('.ynsh-offer__x');
      if(x)x.addEventListener('click',function(){offer.hidden=true;try{sessionStorage.setItem(key,'1');}catch(e){}});
    }
    var track=root.querySelector('.ynsh__track'),slides=root.querySelectorAll('.ynsh__slide'),dots=root.querySelectorAll('.ynsh__dot');
    if(!track||slides.length<2)return;
    var idx=0,timer=null,settle=null,secs=parseInt(root.dataset.autoplay,10)||0;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* The slider takes the height of the slide on screen (after it lands), so short slides leave no gap above the dots */
    track.style.alignItems='flex-start';
    if(!reduce)track.style.transition='height .3s ease';
    function fit(){var s=slides[idx];if(s)track.style.height=s.offsetHeight+'px';}
    function current(){return Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/(track.clientWidth||1))));}
    function go(i){var t=(i+slides.length)%slides.length;track.scrollTo({left:slides[t].offsetLeft,behavior:reduce?'auto':'smooth'});}
    function mark(){idx=current();dots.forEach(function(d,j){d.setAttribute('aria-selected',j===idx?'true':'false');});clearTimeout(settle);settle=setTimeout(fit,140);}
    track.addEventListener('scroll',mark,{passive:true});
    window.addEventListener('resize',function(){idx=current();fit();});
    root.querySelectorAll('img').forEach(function(im){if(!im.complete)im.addEventListener('load',function(){if(slides[idx].contains(im))fit();});});
    fit();
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);restart();});});
    var p=root.querySelector('.ynsh__nav--prev'),n=root.querySelector('.ynsh__nav--next');
    if(p)p.addEventListener('click',function(){go(current()-1);restart();});
    if(n)n.addEventListener('click',function(){go(current()+1);restart();});
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    function start(){if(secs>0&&!reduce&&!timer&&!design){timer=setInterval(function(){go(current()+1);},secs*1000);}}
    function restart(){stop();start();}
    ['mouseenter','focusin','touchstart'].forEach(function(e){root.addEventListener(e,stop,{passive:true});});
    ['mouseleave','focusout'].forEach(function(e){root.addEventListener(e,start);});
    document.addEventListener('visibilitychange',function(){document.hidden?stop():start();});
    start();
  }
  function all(){document.querySelectorAll('.ynsh').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('.ynsh'));});
})();